import { useCallback, useEffect, useRef, useState } from "react";
import { ExperienceProvider, useExperience } from "@/context/ExperienceContext";
import { usePlaybackStory } from "@/hooks/usePlaybackStory";
import { SiteHeader } from "@/components/rrb/SiteHeader";
import { VideoStage } from "@/components/rrb/VideoStage";
import { SceneOverlay, ScrollHint } from "@/components/rrb/SceneOverlay";
import { MobileBar } from "@/components/rrb/MobileBar";
import { FinaleSection } from "@/components/rrb/FinaleSection";
import { LeadModals } from "@/components/rrb/LeadModals";

const useMedia = (q) => {
  const [m, setM] = useState(() => window.matchMedia(q).matches);
  useEffect(() => {
    const mq = window.matchMedia(q);
    const fn = () => setM(mq.matches);
    mq.addEventListener("change", fn);
    return () => mq.removeEventListener("change", fn);
  }, [q]);
  return m;
};

function Story() {
  const { phase, started, scene } = useExperience();
  const mobile = useMedia("(max-width: 767px), (pointer: coarse) and (max-width: 1024px)");
  const reduced = useMedia("(prefers-reduced-motion: reduce)");
  const videoRef = useRef(null);
  const stageRef = useRef(null);
  const storyRef = useRef(null);
  const [textOn, setTextOn] = useState(true);
  const onText = useCallback((v) => setTextOn(v), []);
  const start = usePlaybackStory({ videoRef, stageRef, storyRef, mobile, reduced, onText });

  return (
    <div className="rrb-root" data-phase={phase} data-mobile={mobile ? "1" : "0"} data-reduced={reduced ? "1" : "0"}
      data-started={started ? "1" : "0"} data-scene={scene.id} data-testid="experience-root">
      <div className="rrb-stars" aria-hidden />
      <SiteHeader />
      <VideoStage ref={stageRef} videoRef={videoRef} mobile={mobile} />
      <SceneOverlay textOn={textOn} mobile={mobile} />
      {!started && <ScrollHint mobile={mobile} onStart={start} />}
      <div ref={storyRef} className="rrb-story" data-testid="story-spacer" />
      <FinaleSection />
      <MobileBar />
      <LeadModals />
    </div>
  );
}

export default function Experience() {
  return (
    <ExperienceProvider>
      <Story />
    </ExperienceProvider>
  );
}
